<template>
	<div>
		<h2 class="mw-h1">New Request</h2>
		<p>
			You can use the form below to request a quote for user research recruitment. Requests are usually answered within 24 hours. If you prefer, you can alternatively reach out to Meisterworks.
		</p>
		<v-card class="pa-4">
			<h4 class="mw-h3">Basic Info </h4>
			<v-row>
				<v-col cols="12" sm="8">
					<v-text-field dense label="Request Title" v-model="title" required></v-text-field>
				</v-col>
				<v-col cols="12" sm="4">
					<v-text-field dense label="Your Reference" v-model="clientReference"></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea dense label="Description" v-model="description"></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field dense label="Department / Division / Workstream" v-model="department"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="contracts">
				<v-col v-if="contracts.length > 1" >
					<v-select label="Contract" v-model="contract" :items="contracts" 
					item-text="title"
					item-value="id"
					return-object></v-select>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<h4 class="mw-h3">Segments / Quotas / Profiles</h4>
					<p>Add different target groups you’d like to recruit separately below. Use the ‘add new line’ button to add further segments. </p>
					<AddManyTable :items="segments" :columns="columns"></AddManyTable>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<h4 class="mw-h3">Additional Services</h4>
					<p>	Please select additional services you’d like a quote for below. If you can’t see the service you require, please use the ‘Add Service’ button to add the service you require.  </p>
					<span v-for="item in availableAdditionalCosts" :key="item.name"><v-checkbox dense single-line hide-details v-model="additionalCosts" :value="item" :label="item.name"></v-checkbox></span>
					<p class="text-right">
						<v-dialog v-model="dialog" width="300" >
							<template v-slot:activator="{ on }">
								<v-btn color="primary" v-on="on">Add additional service</v-btn>
							</template>

							<v-card>
								<v-card-title>
									Add Service
								</v-card-title>
								<v-card-text>
									<v-text-field v-model="additionalCostText"></v-text-field>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="primary" text @click="addAdditionalCost"> Add Service</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</p>
				</v-col>
			</v-row>
			<p class="text-right">
				<v-btn color="green" dark @click="saveRequest" v-if="!saved" >Submit Request</v-btn>
			</p>			
		</v-card>
		<v-dialog v-model="savedDialog" width="360px">
			<v-card>
				<v-card-title>Saved</v-card-title>
				<v-card-text>Thank you for submitting your request. We will be in touch as soon as possible</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red" dark @click="savedDialog = false">Close</v-btn>
					<v-btn color="primary" link to="/">Go to Dashboard</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
</div>
</template>

<script>

import Vuex from 'vuex'

	import AddManyTable from "../tools/AddManyTable.vue";
// import MwDataTable from "../tools/MwDataTable.vue";

export default{
	name: "NewRequestForm", 
	data: () => {
		return {
			title: '', 
			department: '',
			description: '',
			dialog: false,
			clientReference: '',
			segments: [], 
			additionalCosts: [],
			availableAdditionalCosts: [
				{ name: "Moderation", requested: true },
				{ name: "Facility", requested: true },
				{ name: "Transcription", requested: true },
				{ name: "Translation", requested: true }
			],
			additionalCostText: '',
			saved: false,
			savedDialog: false
		}
	},
	computed: {
		...Vuex.mapState({
			view: function(state) {
				// if( !state.client ){ return; }
				return state.auth.view 
			},
			user: function(state) {
				if( !this.view ){ return; }
				if( !state.client ){ return; }
				return state.client.user 
			},
			methodologies: function(state) {
				return state.settings.methodologies
			},
			contracts: function(state){
				if( !this.user ){ return; }
				return state.client.contracts
			}
		}),
		contract(){
			if( !this.contracts ){
				return false;
			}
			else{
				return this.contracts[0]
			}

		},
		columns(){
			const self = this;
			let cols = [
				{
					type: "textarea",
					value: "title",
					name: "Title",
					dense: true, 
					rounded: true, 
					filled: true,
					inline: 1
				},
				{
					type: "select",
					value: "sessionType",
					name: "Session Type",
					selected: "sessionType",
					dense: true, 
					rounded: true, 
					filled: true,
					options: self.methodologies,
					inline: 1
				},
				{
					type: "text",
					value: "numberOfSessions",
					name: "# of Sessions",
					dense: true, 
					rounded: true, 
					filled: true,
					number: 1,
					inline: 1
				},
				{
					type: "text",
					value: "numberOfParticipants",
					name: "# of Participants / Session",
					dense: true, 
					rounded: true, 
					filled: true,
					number: 1,
					inline: 1
				},
				{
					type: "text",
					value: "loi",
					name: "Length (mins)",
					dense: true, 
					rounded: true, 
					filled: true,
					number: 1,
					inline: 1
				},
				{
					type: "textarea",
					value: "participantDescription",
					name: "Participant Description",
					dense: true, 
					rounded: true, 
					filled: true,
					inline: 1
				},
			]
			if( this.contract ){
				this.contract.additionalFields.forEach( field => {
					var col = {
						type: field.type,
						value: field.name,
						dense: true, 
						rounded: true, 
						filled: true,
						name: field.description,
						inline: 1
					}
					if( field.type == 'select' ){
						col.options = field.options; 
					}
					cols.push(col)
				})
			}
			cols.push({
				type: "textarea",
				value: "desiredSchedule",
				dense: true, 
				rounded: true, 
				filled: true,
				name: "Desired Schedule / Times",
				inline: 1
			});
			cols.push({
				type: "textarea",
				value: "notes",
				dense: true, 
				rounded: true, 
				filled: true,
				name: "Notes",
				inline: 1
			});
			cols.push({
				type: "button",
				color: "red",
				value: "deleteSegment",
				dense: true, 
				rounded: true, 
				filled: true,
				name: " "
			});
			return cols;
		}
	},
	components: {
		// MwDataTable: MwDataTable,
		AddManyTable: AddManyTable
	},
	methods: {
		addAdditionalCost(){
			let cost = {
				name: this.additionalCostText,
				requested: true
			}
			this.availableAdditionalCosts.push( cost )
			this.additionalCosts.push( cost )
			this.dialog = false;
			this.additionalCostText = '';
		},
		saveRequest(){
			let request = {
				title: this.title,
				status: "new",
				users: {
				}, 
				department: this.department,
				description: this.description,
				clientReference: this.clientReference,
				additionalCosts: this.additionalCosts,
				segments: this.segments,
				publishStatus: "live"
			}
			request.users[this.user.id] = "client";
			request.organisation = this.user.organisation;
			if( this.contract ){
				request.contract = this.contract.id;
			}
			for( var key in request ){
				if( typeof request[key] == 'undefined' ){
					delete request[key]
				}
			}
			this.$store.dispatch("addDoc", {
				data: request,
				collection: "requests"
			}).then( () => {
				this.saved = true
				this.savedDialog = true;
			})
		}
	},
	watch: {
		view(){
			this.$store.dispatch("fetchUser");
		},
		user(){
			if( this.user.organisation ){
				this.$store.dispatch("fetchContracts", this.user.organisation);
			}
		}
	}
}
</script>